import React, { Fragment, useEffect, useState } from "react"
import { deleteBusta, fetchBusta, fetchBuste, fetchCu, fetchCuDetail } from "../../services/api"
import { gruppaBustePerMese } from "../../utils"
import { Link } from "wouter"
import { CheckCircleIcon, PaperClipIcon, XCircleIcon, TrashIcon } from "@heroicons/react/24/outline"
import moment from "moment"
import { months } from "../../config"
import { setCedolinoRead, setCuRead, cuDetail, documentiDetail, setDocumentiRead } from "../../services/api_dipendenti"
import Backbutton from '../../components/back_button';


export default function DocsDetailAr(props) {

  const { loading, token, resourceId } = props
  const [doc, setDoc] = useState({})
  const [fetching, setFetching] = useState(true)


  useEffect(() => {
    if (token && !loading) {
      console.log(token)
      setFetching(true)
    }
    documentiDetail(token, resourceId)
      .then((res) => {
        setDoc(res)
        setFetching(false)
        if (!res.read_at) {
          setDocumentiRead(token, resourceId).then((res) => {
          }).catch((err) => {})
        }
  
      })
      .catch((err) => {
        console.log(err)
        setFetching(false)
      })
  }, [token])


  if (fetching) {
    return <div
      className="
        m-4
      relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      <div role="status">
        <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
      <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
    </div>
  }

  return (
    <>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* top bar */}
        <div className="mt-4 flex items-center justify-between">
          <Backbutton prevLocation={`/areariservata/documenti`} />
        </div>

        {/* layout */}
        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-12">
          {/* card info */}
          <div className="lg:col-span-4">
            <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
              <div className="border-b border-gray-100 px-5 py-4">
                <h3 className="text-sm font-semibold text-gray-900 uppercase">Informazioni</h3>
                <p className="mt-1 text-xs text-gray-500">Dettagli del documento</p>
              </div>
  
              <dl className="divide-y divide-gray-100">

   
                {doc?.nome && (
                  <div className="px-5 py-4">
                    <dt className="text-xs font-semibold text-gray-500 uppercase">Nome</dt>
                    <dd className="mt-1 text-sm font-medium text-gray-900">{doc.nome}</dd>
                  </div>
                )}

                {doc?.descrizione && (
                  <div className="px-5 py-4">
                    <dt className="text-xs font-semibold text-gray-500 uppercase">Descrizione</dt>
                    <dd className="mt-1 text-sm font-medium text-gray-900">{doc.descrizione}</dd>
                  </div>
                )}
  
                {doc?.created_at && (
                  <div className="px-5 py-4">
                    <dt className="text-xs font-semibold text-gray-500 uppercase">Caricato il</dt>
                    <dd className="mt-1 text-sm text-gray-700">
                      {moment(doc.created_at).format("DD/MM/YYYY HH:mm")}
                    </dd>
                  </div>
                )}
  
              </dl>
            </div>
          </div>
  
          {/* viewer */}
          <div className="lg:col-span-8">
            <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
              <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
                <div>
                  <p className="mt-1 text-xs text-gray-500">Anteprima PDF</p>
                </div>
  
                {doc?.download_link && (
                  <a
                    href={doc.download_link}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center rounded-md bg-white px-3 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  >
                    Apri in nuova scheda
                  </a>
                )}
              </div>
  
              <div className="bg-gray-50">
                <iframe
                  src={doc?.download_link}
                  title="Cedolino PDF"
                  frameBorder="0"
                  className="w-full h-[75vh] md:h-[80vh]"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
)}